<template>
  <div>
    <v-col
      cols="12"
      class="pa-0">
      <h4 class="field-header primary">
        Step 2 : เลือกระยะเวลา
      </h4>
    </v-col>
    <v-col cols="12">
      <sub-radio-button
        :old-value="oldDuration"
        :data="periods"
        :editable="editable"
        class="mt-n8"
        @input="bindValue" />
    </v-col>
  </div>
</template>

<script>
import SubRadioButton from '@/components/form/SubRadioButton.vue'

export default {
  components: {
    SubRadioButton
  },
  props: {
    oldDuration: {
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      periods: [
        {
          list: [
            { text: 'ไม่กำหนด', value: 'notSpecify' },
            {
              text: 'ระบุวันและเวลา',
              value: 'specifyDate',
              append: [
                { fieldType: 'input', type: 'date' },
                { fieldType: 'input', type: 'time' }
              ]
            },
            {
              text: 'จำนวน',
              value: 'specifyNumber',
              append: [
                { fieldType: 'input', type: 'number', appendText: 'วัน' }
              ]
            }
          ]
        }
      ]
    }
  },
  methods: {
    bindValue (field, more) {
      this.$emit('input', { field, more })
    }
  }
}
</script>

<style scoped>
.field-header {
  text-align: center;
  padding: 8px;
  color: white;
  border-radius: 10px;
  width: 27%;
  font-size: 14px;
}
</style>
